import { render } from "./EditAd.vue?vue&type=template&id=7b349f83"
import script from "./EditAd.vue?vue&type=script&lang=js"
export * from "./EditAd.vue?vue&type=script&lang=js"
script.render = render

export default script